module.exports = __webpack_public_path__ + "img/dengnavicon4.de759761.png";